import script from "./AccountSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountSetting.vue?vue&type=script&setup=true&lang=js"

import "./AccountSetting.vue?vue&type=style&index=0&id=b18b89d0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b18b89d0"]])

export default __exports__